import React from 'react'

import LeftBar from './leftbar'
import '../styles/index.scss'
import layoutStyles from '../components/layout.module.scss'



const Layout = (props) => {
    console.log(props)
    return (
        <div>
            <LeftBar />
            <div className={layoutStyles.mainContent}>
                {props.children}
            </div>
        </div>
    )
}

export default Layout